<template>
  <div>
    <div class="content">
      <div class="content_content">
        <div class="details" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import HeaderB from "@/components/public/headerB";
import Code from "@/components/public/code";
import Footer from "@/components/public/footer";
export default {
  data() {
    return {
      toHeaderB: {
        title: "湿地简介",
        parent: "走进湿地",
        parentLink: "/stepInWetland/stepInWetland",
        child: "湿地简介",
        childLink: "/stepInWetland/wetlandDescription",
        longTop: "Wetland",
        longBottom: "Introduction",
        shortValue: "",
        isLong: true,
        titleShow: false,
        logoSrc: {}
      },
      content: ""
    };
  },
  components: {
    HeaderB,
    Code,
    Footer
  },
  methods: {
    // 自动判断内容高度，不足则补
    setHeight() {
      setTimeout(function() {
        $(".details").css("height", "auto");
        let contentHeight =
          $(window).height() -
          $(".logo").height() -
          $(".footer").height() -
          20 -
          60;
        if ($(".details").height() < contentHeight) {
          $(".details").height(contentHeight);
        }

        document.documentElement.scrollTop = 300;
      });
    }
  },
  mounted() {
    // 获取数据
    this.axios
      .get(
        this.$store.state.Url10 +
          "wetland/findWetlandList?soId=" +
          this.$store.state.Soid
      )
      .then(data => {
        data = data.data.data[0];
        this.content = data.zhsdWetlandContent;
        this.toHeaderB.titleShow = true;
        this.setHeight();
      })
      .catch(err => {
        console.log(err);
      });
  },
  updated() {
    // 动态设置高度
    if ($(".content_content").height()) {
      if (
        $(".content_content").height() - 60 <
        $(window).height() - $(".logo").height() - $(".footer").height() - 20
      ) {
        $(".content_content").height(
          $(window).height() -
            60 -
            $(".logo").height() -
            $(".footer").height() -
            20
        );
      } else {
        $(".content_content").css("height", "auto");
      }
    }
    setTimeout(function() {
      $(".header_nav li")
        .eq(1)
        .find("span")
        .find("a")
        .attr("class", "header_native");
    }, 0);
  }
};
</script>

<style scoped="scoped">
.content {
  background-color: white;
  padding: 20px 20% 20px 20%;
}
.content > div {
  text-align: left;
  padding: 20px;
  background-color: white;
}

@media only screen and (max-width: 1500px) {
  .content {
    padding: 20px 10% 20px 10%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/stepInWetland/wetlandDescription.vue